import { getBasicContentSchema } from '@/lib/zy-tiptap-utils';
import { Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { ZyAsideNodeView } from './zyaside-node-view';

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        zyAside: {
            insertZyAside: () => ReturnType;
        };
    }
}

export const ZyAsideHeadless = Node.create({
    name: 'zyAside',

    content: function () {
        return getBasicContentSchema();
    },

    group: 'block',

    draggable: true,

    isolating: true,

    addAttributes() {
        return {
            type: {
                default: 'elaboration',
                parseHTML: element => {
                    return element.getAttribute('type') || 'elaboration';
                },
                renderHTML: attributes => {
                    if (!attributes.type) {
                        return {};
                    }
                    return {
                        type: attributes.type,
                    };
                },
            },
            caption: {
                default: '',
                parseHTML: element => {
                    return element.getAttribute('name') || '';
                },
                renderHTML: attributes => {
                    if (!attributes.caption) {
                        return {};
                    }
                    return {
                        name: attributes.caption,
                    };
                },
            },
            id: {
                default: null,
                parseHTML: element => {
                    return element.getAttribute('id');
                },
                renderHTML: attributes => {
                    if (!attributes.id) {
                        return {};
                    }
                    return {
                        id: attributes.id,
                    };
                },
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: 'zyAside',
                getAttrs: element => {
                    if (!(element instanceof HTMLElement)) {
                        return false;
                    }
                    return {
                        type: element.getAttribute('type') || 'elaboration',
                        caption: element.getAttribute('name'),
                        id: element.getAttribute('id'),
                    };
                },
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ['zyAside', HTMLAttributes, 0];
    },

    addCommands() {
        return {
            insertZyAside:
                () =>
                ({ commands }) => {
                    return commands.insertContent({
                        type: 'zyAside',
                        attrs: { type: 'elaboration' },
                        content: [{ type: 'paragraph' }],
                    });
                },
        };
    },
});

export const ZyAside = ZyAsideHeadless.extend({
    addNodeView() {
        return ReactNodeViewRenderer(ZyAsideNodeView);
    },
});

export default ZyAside;
